import { takeEvery } from 'redux-saga/effects';
import {
  sdkMobileStartScreenshareRequested,
  sdkMobileStopScreenshareRequested,
  sdkMobileScreenshareToggled,
  sdkVirtualBackgroundChangedEventRequested,
  sdkMobileMediaTokenUpdated,
} from 'features/sdk/actions';
import { virtualBackgroundActivationFailed } from 'features/virtual-backgrounds/virtualBackgroundsSlice';
import { virtualBackgroundChangedEventSaga } from 'features/sdk/sagas/virtualBackgroundChangedEventSaga';
import { virtualBackgroundNotAppliedEventSaga } from 'features/sdk/sagas/virtualBackgroundNotAppliedEventSaga';
import { mobileStartScreenshareRequestedSaga } from 'features/sdk/sagas/mobileStartScreenshareRequestedSaga';
import { mobileStopScreenshareRequestedSaga } from 'features/sdk/sagas/mobileStopScreenshareRequestedSaga';
import { mobileScreenshareToggledSaga } from 'features/sdk/sagas/mobileScreenshareToggledSaga';
import { mobileMediaTokenUpdatedSaga } from 'features/sdk/sagas/mobileMediaTokenUpdatedSaga';

export default function* sdkWatcher() {
  yield takeEvery(sdkVirtualBackgroundChangedEventRequested, virtualBackgroundChangedEventSaga);
  yield takeEvery(virtualBackgroundActivationFailed, virtualBackgroundNotAppliedEventSaga);
  yield takeEvery(sdkMobileStartScreenshareRequested, mobileStartScreenshareRequestedSaga);
  yield takeEvery(sdkMobileStopScreenshareRequested, mobileStopScreenshareRequestedSaga);
  yield takeEvery(sdkMobileScreenshareToggled, mobileScreenshareToggledSaga);
  yield takeEvery(sdkMobileMediaTokenUpdated, mobileMediaTokenUpdatedSaga);
}
